import React from 'react'
import { Outlet } from 'react-router-dom'

function MainTasks() {
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default MainTasks
